'use client'

import Placeholder from '@ethena/shared-ui/src/components/Placeholder'
import { formatNumber, NumberType } from '@ethena/shared-ui/src/utils/formatNumbers'
import Image from 'next/image'

import { InfoBox } from '@/components/InfoBox'
import { SavingsChart } from '@/components/SavingsChart'
import { SectionHeader } from '@/components/SectionHeader'
import { useSavingsData } from '@/hooks/useSavingsData'

export const SavingsSection = () => {
  const { chartData, headlineSavingValue, setTimeScale, timeScale } = useSavingsData()

  return (
    <section className="landing-section">
      <div className="landing-layout w-full mx-auto flex flex-col items-center justify-center pt-20 lg:pt-[96px] hxl:pt-0">
        <SectionHeader title="The Holy Grail: Internet Money" />
        <div className="flex flex-col gap-6 w-full mx-auto max-w-[1440px] xl:gap-2.5 xl:hxl:gap-4">
          <div className="flex flex-wrap justify-between gap-8 xl:gap-0">
            <div className="w-full xl:w-1/2">
              <InfoBox
                title="Savings Technology For The World"
                description="Global instant access to a dollar savings account"
                image="/trend.svg"
                size="large"
              />
            </div>
            <div className="w-full xl:w-1/2">
              <div className="h-full w-full flex items-center justify-center rounded-[20px] bg-background-primary p-2">
                <div className="bg-gradient-to-l from-[#88B4F5]/60 via-[#202a39] to-background-secondary p-[1px] rounded-[10px] h-full w-full">
                  <div className="h-full w-full rounded-[10px] bg-gradient-to-right p-1 relative overflow-hidden">
                    <div className="py-3 px-4 flex flex-col gap-2.5">
                      <h2 className="text-[28px] font-medium gradient-text justify-start flex items-center sm:justify-end gap-2">
                        <Placeholder isLoading={!headlineSavingValue} classes="w-[105px] h-[37px]">
                          <span>{formatNumber(headlineSavingValue, NumberType.FiatTokenAmt)}</span>
                        </Placeholder>
                      </h2>
                      <p className="text-lg font-medium text-text-muted flex flex-wrap items-center justify-start sm:justify-end gap-2">
                        <span>$100 of</span>
                        <Image src="/shared/sUSDe.svg" alt="sUSDe" width={24} height={24} className="h-6 w-6" />
                        <span>Staked USDe Beginning of 2024</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="rounded-[12px] graph-border-gradient p-[1px]">
            <div className="h-full w-full rounded-[10px] bg-background-primary p-2">
              <div className="rounded-[12px] graph-inner-gradient p-[1px]">
                <div className="h-full w-full rounded-[10px] bg-[linear-gradient(171deg,#16181a_0%,#1b1e25_28%,#09090b_57%,#09090b_100%)] p-5">
                  <div className="w-full h-[400px] lg:h-[290px] lg:hbase:h-[400px] lg:hlg:h-[550px] mb-20 lg:mb-0">
                    <SavingsChart data={chartData} timeScale={timeScale} setTimeScale={setTimeScale} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p className="text-xs text-text-muted/40 font-inter">
            APY data is based upon 2024 weekly data reported by Ethena which assumes no net stake/unstake activity
            during reward vesting periods. All data presented is for informational purposes only and should not be
            construed as advice or a solicitation to acquire a specific asset. Market conditions may change and actual
            future results may vary.
          </p>
        </div>
      </div>
    </section>
  )
}
